import React from 'react';
import Typography from '@material-ui/core/Typography';
import { formatMoney } from 'helpers/moneyFormatter';

export const AdditionItem = ({ addition }) => {
  if (!addition.amount) return null;

  return (
    <Typography style={{ fontSize: '12px' }}>
      {`${addition.amount}x - ${addition.product_option.name} `}
      {addition.product_option.price > 0 ? (
        <b>{formatMoney(addition.product_option.price)}</b>
      ) : null}
    </Typography>
  );
};
